import React from 'react';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  Promesa,
  Pilares,
  Mentora,
  DetallesExperiencia,
  RegistroCursoForm,
  InversionFacilidades,
  CierreContacto,
} from './components';

const LandingMediaKitOratoriaEstrategica = () => {
  return (
    <Box>
      <Container>
        <Hero />
      </Container>
      <Box bgcolor="alternate.main">
        <Container>
          <Promesa />
        </Container>
      </Box>
      <Container>
        <Pilares />
      </Container>
      <Box bgcolor="alternate.main">
        <Container>
          <Mentora />
        </Container>
      </Box>
      <Box bgcolor="alternate.main">
        <Container>
          <DetallesExperiencia />
        </Container>
      </Box>
      <Container>
        <RegistroCursoForm />
      </Container>
      <Container>
        <InversionFacilidades />
      </Container>
      <Box bgcolor="alternate.main">
        <Container>
          <CierreContacto />
        </Container>
      </Box>
    </Box>
  );
};

export default LandingMediaKitOratoriaEstrategica;

